import React, { ReactNode } from "react";
import "./timelineStyles.css";

export type TimelineDotVariant =
  | "success"
  | "info"
  | "warning"
  | "danger"
  | "default";

export interface TimelineItem<T> {
  data: T;
  dotVariant?: TimelineDotVariant;
}

interface TimelineProps<T> {
  items: TimelineItem<T>[];
  renderItem: (data: T, index: number) => ReactNode;
  emptyMessage?: string;
}

export default function Timeline<T>({
  items,
  renderItem,
  emptyMessage = "No timeline entries found.",
}: TimelineProps<T>) {
  if (!items.length) {
    return <div className="rf-timeline-empty">{emptyMessage}</div>;
  }

  return (
    <div className="rf-timeline">
      {items.map((item, index) => {
        const variant = item.dotVariant ?? "default";
        return (
          <div className="rf-timeline-item" key={index}>
            <div className={`rf-timeline-dot rf-timeline-dot--${variant}`} />
            <div className="rf-timeline-card">{renderItem(item.data, index)}</div>
          </div>
        );
      })}
    </div>
  );
}
